var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 125 100",
    viewBox: "0 0 125 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.999,
    cy: 72.862,
    rx: 6.6857,
    ry: 6.5283,
    stroke: "#EE7203",
    strokeWidth: 3.7,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.999,
    cy: 72.548,
    rx: 14.124,
    ry: 13.792,
    stroke: "#000000",
    strokeWidth: 3.017,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.525 58.439v-45.306h12.947v46.873",
    stroke: "#000000",
    strokeWidth: 3,
    style: {
      paintOrder: "stroke fill markers"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonde);
export default __webpack_public_path__ + "static/media/sonde.39bc56a56f3d8fd6b7d2d961e1298abf.svg";
export { ForwardRef as ReactComponent };